import { Injectable } from "@angular/core";
import * as imageCompression from "browser-image-compression";
import { environment } from "src/environments/environment";

const RESULT = "result";
@Injectable({
  providedIn: "root",
})
export class ImageCompressService {
  constructor() {}

  async handleImageUpload(imageFile: File): Promise<File> {
    const options = {
      maxSizeMB: environment.maxPhotoSizeInKb / 1024,
      maxWidthOrHeight: 1920,
      useWebWorker: false,
    };
    try {
      return await imageCompression.default(imageFile, options);
    } catch (error) {
      console.error(error);
    }
  }

  async handleCanvasToFile(canvas: HTMLCanvasElement): Promise<File> {
    return imageCompression.default.canvasToFile(
      canvas,
      "image/jpeg",
      "one-tool-camera-image",
      Date.now()
    );
  }

  async Base64ToFile(url: string): Promise<File> {
    return imageCompression.default.getFilefromDataUrl(url, "name");
  }

  async getBase64fromFile(file: any): Promise<string> {
    return imageCompression.default.getDataUrlFromFile(file);
  }
}
